import {observable} from "mobx";
import {MobXHelper} from "common-import/helpers";
import api from "./Contact.API";

const { makePersit } = MobXHelper;

const PERSIST_STORE_ITEM = {
  USER_DATA: "USER_STORE_USER_DATA"
};

class Store {
  constructor() {

  }

  @observable currentContactList = [];

  getContactList = async (companyTaxCode) => {
    const res = await api.list({ companyTaxCode });
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  createContact = async data => {
    const res = await api.create(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  update = async data => {
    const res = await api.update(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  delete = async data => {
    const res = await api.delete(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  detail = async data => {
    const res = await api.detail(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };
}

export default new Store();



// WEBPACK FOOTER //
// ./src/services/contact/Contact.Store.js